import { render, staticRenderFns } from "./workshop-details.vue?vue&type=template&id=3c6ecc35&scoped=true&"
import script from "./workshop-details.vue?vue&type=script&lang=js&"
export * from "./workshop-details.vue?vue&type=script&lang=js&"
import style0 from "./workshop-details.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./workshop-details.vue?vue&type=style&index=1&id=3c6ecc35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ecc35",
  null
  
)

export default component.exports